import PropTypes from 'prop-types';
import IconButton from '@ui/components/IconButton/IconButton';
import { Badge, Box, Group, Stack, Title } from '@mantine/core';
import Text from '@ui/components/Text/Text';

import MemberPropType from '../../types/member';
import { AVAILABLE_ROLES_NAMES_BY_KEY } from '../../entities/workspaceRole';

import UserAvatar from '../UserAvatar/UserAvatar';

import './WorkspaceMemberWithRole.scss';

const WorkspaceMemberWithRole = ( {
	member, showDeleteIcon, onDeleteClicked
} ) => {
	const projectsCount = member.ownedProjectsCount;
	const isOwner = ( member.roleID === 'WorkspaceOwner' );

	return (
		<Group className="WorkspaceMemberWithRole" spacing={2} w="100%" position="apart" noWrap style={{ paddingLeft: 6 }}>
			<Group spacing={16} style={{ flex: 1 }} position="left" noWrap>
				<Box w="34px" h="34px">
					<UserAvatar user={member.user} />
				</Box>
				<Stack spacing={0} className="member-info">
					<Group spacing={6} noWrap>
						<Title order={6} style={{ fontSize: 14, fontWeight: 600, color: 'var(--color-text-primary)', letterSpacing: 0 }}>
							{member.user.name}
						</Title>
						{isOwner && (
							<Badge color="blue" size="xs">Me</Badge>
						)}
						{member.isLimitedEditor && (
							<Badge color="gray.5" size="xs" variant="filled">Limited Editor</Badge>
						)}
					</Group>
					<Text lineClamp={1} style={{ fontSize: 14, fontWeight: 400, letterSpacing: '0.14px', color: 'var(--color-text-secondary)' }}>{member.user.email}</Text>
				</Stack>
			</Group>
			<Text w="120px" style={{ fontSize: 12, fontWeight: 400, lineHeight: '18px', letterSpacing: '0.13px', color: 'var(--color-text-secondary)' }}>{projectsCount} Owned</Text>
			<Text w="120px" style={{ fontSize: 12, fontWeight: 400, lineHeight: '18px', letterSpacing: '0.13px', color: 'var(--color-text-secondary)' }}>
				{AVAILABLE_ROLES_NAMES_BY_KEY[ member.roleID ]}
			</Text>
			<Box w="40px" align="center">
				{showDeleteIcon && (
					<IconButton
						className="remove"
						icon="delete_outlined"
						size={20}
						color="red.6"
						onClick={onDeleteClicked}
					/>
				)}
			</Box>
		</Group>
	);
};

WorkspaceMemberWithRole.propTypes = {
	member: MemberPropType.isRequired,
	onDeleteClicked: PropTypes.func,
	showDeleteIcon: PropTypes.bool
};

WorkspaceMemberWithRole.defaultProps = {
	onDeleteClicked: () => {},
	showDeleteIcon: false
};

export default WorkspaceMemberWithRole;
